import {useImmersionMode, useRoute} from '#imports';
import {
    AutocompleteOrganizationApi,
    type HTTPHeaders,
    AdvancedSearchApi,
    AdvancedSearchAuthenticatedApi,
    AutocompleteSkillApi,
    BusinessSectorsApi,
    CategoryPredictionsApi,
    Configuration,
    PoolOfFreelancersApi,
    SearchProfilesApi,
    ShortlistApi,
    SuggestSkillsApi,
    ClientOnboardingApi,
    AdminApi,
} from '@api';

class ImmersionConfiguration extends Configuration {
    private readonly getCustomHeaders: () => HTTPHeaders;

    constructor({getCustomHeaders}: {getCustomHeaders: () => HTTPHeaders}) {
        super({basePath: ''});
        this.getCustomHeaders = getCustomHeaders;
    }

    override get headers(): HTTPHeaders | undefined {
        return {
            ...super.headers,
            ...this.getCustomHeaders(),
        };
    }
}

export function useApis() {
    // Handle immersion header
    const route = useRoute();
    const {getImmersionHeaderFromCurrentRoute} = useImmersionMode();
    const apiConfiguration = new ImmersionConfiguration({
        getCustomHeaders: () => getImmersionHeaderFromCurrentRoute(route),
    });

    const adminApi = new AdminApi(apiConfiguration);
    const advancedSearchApi = new AdvancedSearchApi(apiConfiguration);
    const advancedSearchAuthenticatedApi = new AdvancedSearchAuthenticatedApi(apiConfiguration);
    const poolOfFreelancersApi = new PoolOfFreelancersApi(apiConfiguration);
    const searchApi = new SearchProfilesApi(apiConfiguration);
    const shortlistApi = new ShortlistApi(apiConfiguration);
    const autocompleteSkillApi = new AutocompleteSkillApi(apiConfiguration);
    const suggestSkillsApi = new SuggestSkillsApi(apiConfiguration);
    const autocompleteOrganizationApi = new AutocompleteOrganizationApi(apiConfiguration);
    const businessSectorsApi = new BusinessSectorsApi(apiConfiguration);
    const categoryPredictionsApi = new CategoryPredictionsApi(apiConfiguration);
    const clientOnboardingApi = new ClientOnboardingApi(apiConfiguration);

    return {
        adminApi,
        advancedSearchApi,
        advancedSearchAuthenticatedApi,
        categoryPredictionsApi,
        poolOfFreelancersApi,
        searchApi,
        shortlistApi,
        autocompleteSkillApi,
        suggestSkillsApi,
        autocompleteOrganizationApi,
        businessSectorsApi,
        clientOnboardingApi,
    };
}
